import { cn } from "@/lib/utils"

import React from "react"
import { generateDeterministicColor } from "./utils"

interface ColorAvatarProps {
  /**
   * Input string to generate the avatar color
   */
  input: string
  /**
   * Optional size in pixels (defaults to 40)
   */
  size?: number
  /**
   * Optional CSS class name
   */
  className?: string
}

/**
 * A circular avatar component that generates a consistent color based on input string
 */
export const EmptyAvatar: React.FC<ColorAvatarProps> = ({
  input,
  className = "",
}) => {
  const { base, light } = generateDeterministicColor(input)

  return (
    <div className={cn(`h-full w-full rounded-full relative`, className)}>
      {/* Base circle */}
      <div
        className="absolute inset-0 rounded-full"
        style={{ backgroundColor: base }}
      />

      {/* Radial gradient overlay */}
      <div
        className="absolute inset-0 rounded-full opacity-75"
        style={{
          background: `radial-gradient(circle at 30% 30%, ${light} 0%, transparent 60%)`,
        }}
      />
    </div>
  )
}
